import { Link } from "react-router-dom";


export default function NavBar({loggedIn, logOut, setMakeActivity, setMakeRoutine, setEditRoutine, setAttachActivity, setEditRoutineActivity, setFromActivities, setActivityId}) {
    return (
        <section id="navbar">
            <h1 id="title">Fitness Tracker</h1>
            <div className="header-link-container">
                <Link to="/" className="header-link" onClick={(() => {
            event.preventDefault();
            setMakeRoutine(false);
            setMakeActivity(false);
            setActivityId('');
            setFromActivities(false);
            setEditRoutine(false);
            setAttachActivity(false);
            setEditRoutineActivity(false);
        })}>Home</Link>
                <Link to="routines" className="header-link" onClick={(() => {
            event.preventDefault();
            setMakeRoutine(false);
            setMakeActivity(false);
            setActivityId('');
            setFromActivities(false);
            setEditRoutine(false);
            setAttachActivity(false);
            setEditRoutineActivity(false);
        })}>Routines</Link>
                {loggedIn ? <Link to="my_routines" className="header-link" onClick={(() => {
            event.preventDefault();
            setMakeRoutine(false);
            setMakeActivity(false);
            setActivityId('');
            setFromActivities(false);
            setEditRoutine(false);
            setAttachActivity(false);
            setEditRoutineActivity(false);
        })}>My Routines</Link> : null}
                <Link to="activities" className="header-link" onClick={(() => {
            event.preventDefault();
            setMakeRoutine(false);
            setMakeActivity(false);
            setActivityId('');
            setFromActivities(false);
            setEditRoutine(false);
            setAttachActivity(false);
            setEditRoutineActivity(false);
        })}>Activities</Link>
                {
                    loggedIn ? <Link to="/" className="header-link" onClick={() => {
                        logOut();
                        setMakeRoutine(false);
                        setMakeActivity(false);
                        setActivityId('');
                        setFromActivities(false);
                        setEditRoutine(false);
                        setAttachActivity(false);
                        setEditRoutineActivity(false);
                    }}>Log Out</Link> : <Link to="account" className="header-link">Log In</Link>
                }
            </div>
        </section>
    )
};